import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "~/Core/Components/shadcn/ui/sheet";

export function Terms({ children }: { children?: React.ReactNode }) {
  return (
    <Sheet>
      <SheetTrigger asChild>{children ?? <a role="button">Terms of Use</a>}</SheetTrigger>
      <SheetContent className="top-0 max-w-[480px] bg-neutrals-pale-sand p-0  outline-none">
        <div className="grid flex-1 auto-rows-min gap-0  overflow-y-auto max-h-[100%]">
          <SheetHeader className="py-10  px-12 sticky top-0 bg-neutrals-pale-sand ">
            <SheetTitle className="!text-larg-medium text-primary-darkest-green !leading-9">Musahama’s Terms of Use</SheetTitle>
          </SheetHeader>
          <hr className="m-0" />
          <div
            className=" px-12   prose prose-p:text-small-light prose-li:text-small-light prose-p:text-secondary-dark-grey 
          prose-h2:text-secondary-darkest-grey prose-h2:text-regular-regular prose-h2:mt-9">
            <div className="prose prose-lg prose-headings:text-primary-darkest-green prose-headings:font-bold prose-p:text-gray-600 prose-p:leading-relaxed prose-a:text-primary-green hover:prose-a:text-primary-darkest-green prose-li:text-gray-600 max-w-none">
              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Terms of Use</h2>
                <p>
                  Your access to and use of the Public Investment Fund’s (“PIF”) Musahama Platform (“Platform”) and any content, tools features and
                  functionality offered on or through the Platform is subject to and governed by the following Terms of Use (“Terms”), the Platform’s
                  Privacy Notice, and the applicable laws and regulations of the Kingdom of Saudi Arabia.
                </p>

                <p>
                  If you access or use the Platform, you are agreeing to these Terms. If you use the Platform on behalf of a company or an entity,
                  then “you” includes such company or entity and you represent and warrant that you are: (a) an authorized representative of that
                  company or entity with the authority to bind that entity to these Terms; and (b) you agree to these Terms on behalf of such company
                  or entity. PIF may, at its sole discretion, amend these Terms with immediate effect and your continuous use of the Platform is
                  deemed consent and approval to such amendments.
                </p>
              </div>
              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Usage Content</h2>

                <p>
                  In using the Platform, you may input, upload/or submit documents, data or other information in any form (“Your Content”) into the
                  Platform.
                </p>

                <p>By submitting Your Content through the Platform, you:</p>

                <p>
                  (a) represent that you have obtained all rights, licenses, consents, permissions, power and/or authority necessary to submit and use
                  (and allow us to use) such content in connection with the services provided by the Platform; (b) represent and warrant the
                  submission of Your Content in connection with your use of the Platform, including to generate output, will not breach any law,
                  contractual obligations, or any third party’s terms and conditions associated with such content; and (c) agree to the disclosure and
                  sharing of Your Content with third parties in connection to the services provided by the Platform.
                </p>

                <p>
                  The Platform uses Artificial Intelligence (“AI”) tools and functionalities to produce responses, insight and output (“Output”) based
                  on and inclusive of Your Content. The Platform does not guarantee the accuracy of any Output generated in and by the Platform and
                  you must always evaluate the accuracy of any Output.
                </p>

                <p>By using the Platform, you acknowledge and agree to the following:</p>

                <ol className="space-y-2">
                  <li>
                    the Output generated by the Platform may be subject to inaccuracy, contain outdated information, be biased, or have misleading
                    content;
                  </li>
                  <li>
                    you must consistently verify the validity and accuracy of the Output, particularly when using it for official reports and
                    documents; and
                  </li>
                  <li>
                    the Output may not adhere to intellectual property protections or regulations, and you understand the necessity for continuous
                    verification.
                  </li>
                </ol>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Obtaining Local Content Data</h2>

                <p>
                  By registering on the Platform, you acknowledge and agree that the Platform and its authorized representatives may collect, process,
                  and disclose Your Content to the Local Content and Government Procurement Authority (LCGPA) for the purpose of obtaining local
                  content performance data including the local content percentage and local content certificate by LCGPA.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Other Commercial Data</h2>

                <p>
                  By registering on the Platform, you acknowledge and agree that the Platform and its authorized representatives may collect, process,
                  and disclose commercial data about you that is registered with other government entities, including but not limited to your
                  commercial registration number and your manufacturing status for purposes of providing services through the Platform.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Content Processing</h2>

                <p>
                  The Platform hosts Your Content locally and processes it using advanced analytics to enhance user experience, and deliver tailored
                  services, such as customized report optimization, future simulation and recommendations. This processing may include, but not
                  limited to, content categorization, personalized insights, trends and patterns, and recommendations.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Use of the Platform</h2>

                <p>
                  The Output of this Platform is available for general information, guidance and research only, and PIF does not represent nor warrant
                  the accuracy, reliability, or completeness of the information provided in the Output.
                </p>

                <p>By using this Platform, you agree and undertake not to:</p>

                <ol className="space-y-2">
                  <li>
                    use the Platform in claims to offer investment, banking, or financial services, or any other services, or in requesting monetary
                    deposits or financial and/or personal information, or any fraudulent activity;
                  </li>
                  <li>use the Platform, by post or publish or otherwise, in a defamatory, obscene, infringing, or disparaging way;</li>
                  <li>
                    upload files containing viruses or corrupt data, attack this Platform in any way including using malicious or harmful technology,
                    or using software to interfere with the proper operation of the Platform;
                  </li>
                  <li>
                    upload any content or direct the Platform to generate any Output that violates applicable laws and regulations, breaches
                    contractual restrictions, infringes upon the intellectual property rights of others, or violates the privacy rights of any
                    individuals;
                  </li>
                  <li>misuse or direct the Platform to engage in activities that are illegal or unlawful in the Kingdom of Saudi Arabia;</li>
                  <li>use the Platform in any way to create spam, phishing, or produce any unsolicited communications;</li>
                  <li>attempt to obtain unauthorized access to the Platform, servers or any connected databases, portals, or devices; and</li>
                  <li>
                    create a link to this Platform in any way suggesting or claiming PIF or the Platform’s association, endorsement, or approval.
                  </li>
                </ol>

                <p>
                  Any breach of these Terms, misuse or abuse of any content or material on the Platform, or unauthorized access to the Platform is
                  strictly prohibited and may result in termination of the services, claims for damages and/or criminal offenses as per the applicable
                  laws and regulations in the Kingdom of Saudi Arabia.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Security and Acceptable Use</h2>

                <p>
                  In consideration of using the Platform, you confirm that you have read, understood and agree to comply with the Terms and statements
                  below and you shall abide by them while using or accessing the Platform:
                </p>

                <ol className="space-y-2">
                  <li>
                    You acknowledge that all data stored on or originating from, and all communications transmitted or received using, the Platform,
                    excluding Your Content, are considered the property of PIF.
                  </li>
                  <li>
                    You will not copy, distribute, lose, misuse, disclose or modify any information related to the Platform without prior approval
                    from PIF.
                  </li>
                  <li>
                    You must comply with, the Platform’s/PIF’s requirements made available to you on the Platform or PIF’s website, and the laws of
                    the Kingdom of Saudi Arabia and any other relevant regulations, where applicable.
                  </li>
                  <li>
                    You will not attempt any unauthorized access to, interference with or disruption of any software, data, documents or systems
                    available on or through the Platform.
                  </li>
                  <li>
                    You will not copy, download, or upload any material or any portion protected by copyright without proper authorization from the
                    copyright owner.
                  </li>
                  <li>
                    You will report any security incidents, unauthorized access, or suspicious activities promptly to the designated support team.
                  </li>
                  <li>
                    You agree to keep all information, including supplier information and business data, confidential and not disclose it to any third
                    party without prior written consent from PIF, and to use it only for your internal purposes and not for the benefit of any other
                    person or entity.
                  </li>
                </ol>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Intellectual Property Rights</h2>

                <h3>Ownership of Platform</h3>
                <p>
                  The Platform, including their “look and feel” (e.g., text, graphics, images, logos), proprietary content, information and other
                  materials, are protected under copyright, trademark and other intellectual property laws. You agree that PIF and/or its licensors
                  own all right, title and interest in and to the Platform (including any and all intellectual property rights therein) and you agree
                  not to take any action(s) inconsistent with such ownership interests. PIF and/or its licensors or service providers reserve all
                  rights in connection with the Platform and its content (other than Your Content), including, without limitation, the exclusive right
                  to create derivative works.
                </p>

                <h3>Your Content</h3>
                <p>
                  In connection with your use of the Platform, you may be able to input, upload or submit Your Content. As between PIF and you, PIF
                  does not claim any ownership in Your Content; provided that, PIF and their respective licensors own and will continue to own the
                  Platform and any and all other software or technology that was used to generate any Output.
                </p>

                <p>
                  By using the Platform and uploading Your Content, you grant us a license to access, use, host, cache, store, reproduce, transmit,
                  display, publish, distribute, and modify Your Content to operate, improve, promote and provide the Platform, including to reproduce,
                  transmit, display, publish and distribute Output based on the content you input. You agree that these rights and licenses are
                  royalty free, transferable, sub-licensable, worldwide and irrevocable (for so long as Your Content is stored with us), and include a
                  right for us to make Your Content available to, and pass these rights along to, others with whom PIF have contractual relationships
                  related to the provision of the Platform, solely for the purpose of providing such services associated with the Platform, and to
                  otherwise permit access to or disclose Your Content to third parties if PIF determines such access is necessary to achieve
                  legitimate interests of PIF and/or the Platform or comply with legal obligations.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Suspension and Termination</h2>

                <p>
                  You are free to stop using the Platform at any time. PIF reserves the right to suspend or terminate your access to the Platform or
                  delete your account if you breach any of these Terms, the Privacy Notice, the applicable laws and regulations of the Kingdom of
                  Saudi Arabia, or if your use of the Platform could cause risk or harm to the Platform or other users.
                </p>

                <p>PIF may also decide to discontinue the Platform at any time.</p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Assignment of Rights</h2>

                <p>
                  You may not assign or transfer any rights or obligations under these Terms without PIF’s prior consent and any attempt to do so will
                  be void.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Limitation of Liability</h2>

                <p>
                  Your access to and use of the Platform and any reliance on the information provided on or by this Platform including any Outputs, is
                  strictly at your sole risk. PIF, its affiliates, related companies, officers, directors, employees, agents, representatives,
                  partners and licensors, developers, providers and/or its agents (“PIF Entities”) do not accept any liability in and you agree that
                  PIF Entities shall in no event be liable for any event for any claims, injury, losses, or damages (direct or indirect) of any kind
                  whatsoever resulting from or in connection with the use this Platform, its content, or any links, portals, or pages provided in the
                  Platform (including any Output) or the Terms.
                </p>

                <p>
                  Any statements or content that mention or describe a third party does not and should not be construed to acknowledge or present the
                  existence of any legal relationship, duties or obligations, between the Platform and any third party.
                </p>

                <p>
                  You are solely responsible for the information you submit into or provide through the Platform. You agree that PIF Entities shall
                  have no liability to you or any other third party for any accidental, unlawful, breach, unauthorized destruction, alteration,
                  access, disclosure, use, loss or corruption of any such data (“Claims”), and you hereby waive any right of action against PIF
                  Entities arising from any such Claims.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Disclaimer of Warranties</h2>

                <p>
                  You understand and agree that the Platform is provided on an “as is” and “as available” basis and PIF, its affiliates, related
                  companies, officers, directors, employees, agents, representatives, partners and licensors makes no express or implied
                  representations or warranties and disclaims all liability for: any kind related to this Platform or the materials contained on this
                  Platform including (a)the completeness, accuracy, availability, timeliness, security or reliability of the Platform; (b) any harm to
                  your computer system, loss of data, or other harm that results from your access to or use of the Platform; (c) the operation or
                  compatibility with any other application or any particular system or device; (d) whether the Platform will meet your requirements or
                  be available on an uninterrupted, secure or error-free basis; and (e) the deletion of, or the failure to store or transmit, Your
                  Content and other communications maintained by the Platform.
                </p>

                <p>
                  Nothing contained on or through the use of this Platform shall be construed as providing consultation or advice to you. You
                  acknowledge that any Output is not a substitute for advice from a qualified professional. You should not rely on the Platform or any
                  Output for advice of any kind, including legal, investment, financial or other professional advice.
                </p>

                <p>
                  You also acknowledge that (a) the Platform may generate Output containing incorrect, biased, or incomplete information. PIF shall
                  have no responsibility or liability to you for the infringement of the rights of any third party in your use of any Output; and (b)
                  due to the nature of generative artificial intelligence tools, other users of the Platform may create and use their own Output that
                  is similar or the same as your Output, such as because the same or similar input was provided, and you agree that such other users
                  can use their own individually created Output for their own internal business purposes.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Indemnification</h2>

                <p>
                  By entering into these Terms and accessing or using the Platform, you agree to defend, indemnify and hold harmless, to the fullest
                  extent by applicable law, PIF Entities from and against any and all liabilities, costs, demands, causes of action, damages and
                  expenses (including reasonable attorney’s fees) incurred by the PIF Entities arising out of or in any way in connection with (a)
                  your breach of any of the provisions of these Terms or any applicable law or regulation; (b) your violation of any rights of any
                  third party; (c) your misuse of the Platform; (d) Your Content; or (e) your negligence or willful misconduct.
                </p>

                <p>
                  If you are obligated to indemnify any PIF Entity hereunder, then you agree that PIF (or, at its discretion, the applicable PIF
                  Entity) will have the right, in its sole discretion, to control any action or proceeding and to determine whether PIF wishes to
                  settle, and if so, on what terms, and you agree to fully cooperate with PIF in the defense or settlement of such claim.
                </p>

                <p>
                  Any failure or delay by PIF to exercise or enforce any right or provision hereof shall in no way constitute a waiver of such right
                  or provision.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Fraud and Misuse Warning</h2>

                <p>
                  PIF strongly cautions against any communication that impersonates its name, its employees’ names or the Platform’s name, for the
                  purpose of requesting funds or remittances, or any other illegal or unauthorized purposes, such as money laundering, financing of
                  terrorism, bribery, and corruption. We stress the need to report any information on financial crimes, suspicious activities, or
                  other illegal activities to PIF at [vendorwhistleblowing@pif.gov.sa], and to report to relevant law enforcement agencies, as
                  applicable.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Virus Protection</h2>

                <p>
                  You are required to run antivirus programs to test and scan the safety of the Platform’s material, content, or downloaded files.
                  While the Platform takes reasonable effort to protect and test the contents of its Platform, PIF will not be liable nor responsible
                  for any damages, loss, or interruptions to you, your devices or your data that may result from using this Platform or downloading
                  its content.
                </p>
              </div>

              <div className="my-8 rounded-2xl ">
                <h2 className="!mt-0">Applicable Law and Dispute Resolution</h2>

                <p>
                  These Terms, including the Privacy Notice, and your use of this Platform are governed by the laws of the Kingdom of Saudi Arabia.
                </p>

                <p>
                  In the event of any contractual or non-contractual dispute, controversy, or claim arising out of or in connection with these Terms
                  (a “Dispute”), you and PIF agree to first attempt to resolve the Dispute through good faith negotiations. Either party may initiate
                  the negotiations by providing a written notice to the other party outlining the nature of the Dispute (“Dispute Notice”). The
                  parties shall use their best efforts to resolve the Dispute within sixty (60) days from the Dispute Notice.
                </p>

                <p>
                  If the Dispute is not resolved through good faith negotiations, either party may bring the Dispute before the competent courts of
                  the Kingdom of Saudi Arabia. Each party hereby irrevocably submits to the exclusive jurisdiction of such courts.
                </p>

                <p>For any questions, please contact us.</p>
              </div>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
